import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux';
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import $ from 'jquery'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import CustomField from '../components/CustomField/CustomField.js'
import Button from '../components/Button/Button.js'
import Doc from '../components/Doc/Doc.js'
import PatternThumbnail from '../components/PatternThumbnail/PatternThumbnail.js'

import {
  tryToFetchDocCategories,
  tryToFetchDocTags,
  tryToFetchDocs,
  tryToFetchDoc,
  tryToFetchDocById,
  tryToGetOfficialPatterns
} from '../actions/actions.export'


var pf_config = require('../pf_config.json');

let docSearchTimeout;

class DocsRoute extends Component {

  constructor(props){
    super(props);

    this.state = {
      search: "",
      searching: false
    }

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSingleDocRequest = this.handleSingleDocRequest.bind(this);
  }

  componentDidMount(){
    const { dispatch, docs } = this.props;
    window.document.title = "Docs - Pattycake";

    this.update(this.props);

    dispatch(tryToFetchDocCategories());
    dispatch(tryToFetchDocTags());
    dispatch(tryToGetOfficialPatterns());

    

    if(this.props.match.params.slug){
      this.handleSingleDocRequest(this.props);
    } else {
      if(!docs.docCache[41]) dispatch(tryToFetchDocById({id: 41}));
      if(!docs.docCache[20]) dispatch(tryToFetchDocById({id: 20}));
      if(!docs.docCache[25]) dispatch(tryToFetchDocById({id: 25}));

      if(!docs.docCache[174]) dispatch(tryToFetchDocById({id: 174}));
      if(!docs.docCache[147]) dispatch(tryToFetchDocById({id: 147}));
      if(!docs.docCache[141]) dispatch(tryToFetchDocById({id: 141}));
      if(!docs.docCache[205]) dispatch(tryToFetchDocById({id: 205}));

    }

  }


  componentWillReceiveProps(newprops){

    this.update(newprops);
    
    if(!newprops.docs.tryingToFetchDocs){
      this.setState({
        searching: false
      })
    }

    if(newprops.match.params.slug){
      this.handleSingleDocRequest(newprops);
      this.setState({
        searching: false
      })
    }
  }

  handleSingleDocRequest(newprops){
    const { dispatch} = this.props;
    const docs = newprops.docs;

    if(docs.tryingToFetchDoc || docs.postError) return;

    if(docs.currentDocs.length === 1 && docs.docCache[docs.currentDocs[0]].slug == newprops.match.params.slug) return;

    this.setState({
      search: "",
      searching: false
    });
    dispatch(this.props.change('search', ''));
    dispatch(tryToFetchDoc({
      slug: newprops.match.params.slug
    }));
  }

  handleSearchChange(e){
    const { dispatch } = this.props;

    this.setState({
      search: e,
      searching: true
    })

    clearTimeout(docSearchTimeout);
    docSearchTimeout = setTimeout((e)=>{
      if(window.location.pathname !== '/docs'){
        dispatch(push('/docs'));
      }
      dispatch(tryToFetchDocs({
        search: this.state.search
      }))
    }, 1000)
  }

  handleSearchSubmit(e){
    e.preventDefault();
  }


  update(newprops){
    const { dispatch } = this.props;

    const docs = newprops.docs;

    if(this.state.search || newprops.match.params.slug || docs.tryingToFetchDocs || docs.tryToFetchDocCategories || docs.tryingToFetchDocTags || docs.categories.length == 0 || docs.tags.length == 0) return;

    var search = window.location.search.substring(1);
    let params = {};
    if(search){
      params = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
    }

    if(newprops.match){
      if(newprops.match.params.tagSlug){
        for(let i in docs.tags){
          if(docs.tags[i].slug == newprops.match.params.tagSlug){
            params.tag = docs.tags[i].id;
            this.setState({
              currentTag: docs.tags[i].name
            })
          }
        }
      }
      if(newprops.match.params.categorySlug){
        for(let i in docs.categories){
          if(docs.categories[i].slug == newprops.match.params.categorySlug){
            params.category = docs.categories[i].id;
            this.setState({
              currentCategory: docs.categories[i].name
            })
          }
        }
      }
    }

    if(params.page) params.page = parseInt(params.page);

    console.log(newprops.match);
    console.log(params);

    let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

    if(queryString !== docs.lastQueryString){
      dispatch(tryToFetchDocs(params))
    }
  }

  render(){
    const { user, docs, patternManager } = this.props;

    let slug = this.props.match.params.slug;
    let tagSlug = this.props.match.params.tagSlug;
    let categorySlug = this.props.match.params.categorySlug;

    let isHome = window.location.pathname == '/docs';

    function decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

    return <div className="content-wrapper">
    
      <div className="home">
        
        <div className="docs">
          <div className="docs-menu">
            <nobr>
              <Link to="/" className="brand-font">
                <span className="brand-space-fix">P</span>attycake
              </Link>
            </nobr>
            <form name="DocsRouteForm" onSubmit={this.handleSearchSubmit}>
              <CustomField
                value={this.state.search}
                name="search"
                noLabel={true}
                placeholder="search the docs"
                icon="fa-search"
                onChange={this.handleSearchChange}
              />
            </form>
            <div className="docs-menu-links">
              <Link to="/docs" className={"docs-menu-link " + (isHome ? "docs-menu-link-active" : "")}>Introduction</Link>
              {
                docs.menu_tree.map((c,i)=>{

                  let child_is_current = false;
                  for(var j in c.children){
                    if(c.children[j].slug == categorySlug){
                      child_is_current = true;
                      break;
                    }
                  }

                  if(categorySlug == c.slug || child_is_current){
                    return <div key={i}>
                      <Link to={"/docs/in/category/" + c.slug} className="docs-menu-link docs-menu-link-active">{decodeHtml(c.name)}</Link>                          
                      {
                        c.children.map((child,j)=>{
                          return <Link to={"/docs/in/category/" + child.slug} key={j} className={"docs-menu-link docs-menu-link-child " + (child.slug == categorySlug ? "docs-menu-link-active" : "")}>{decodeHtml(child.name)}</Link>
                        })
                      }
                    </div>
                  }

                  return <Link to={"/docs/in/category/" + c.slug} key={i} className="docs-menu-link">{decodeHtml(c.name)}</Link>
                })
              }
            </div>
          </div>
          <div className="docs-content">
            <div className="docs-header">
              <div className="flex-split">
                <div className="list-left">
                  
                </div>
                <div className="list-right">
                  { 
                    !user.isLoggedIn && <Link to="/new/drawing" className="list-item button-link d-none d-md-block">
                      <Button display={<span>Try Pattycake for Free &nbsp;<i className="fad fa-angle-double-right"/></span>} color="primary" size="medium"/>
                    </Link> 
                  }
                  { user.isLoggedIn && <Link to="/new/drawing" className="list-item button-link d-none d-md-block">
                    <Button display={<span>Launch Pattycake &nbsp;<i className="fad fa-angle-double-right"/></span>} color="primary" size="medium"/>
                  </Link> }
                </div>         
              </div>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  {
                    // one specific doc
                    (slug && !this.state.search) && 
                    (
                      <div className="col-md-9">
                        {
                          (docs.currentDocs.length == 1 && !docs.tryingToFetchDoc) ?
                          <Doc doc={docs.docCache[docs.currentDocs[0]]}/>
                          :
                          <Doc/>
                        }
                      </div>
                    )
                  }
                  
                  {
                    // search results
                    (this.state.search !== "" && !slug && !tagSlug && !categorySlug) && 
                    <div>
                      {
                        (docs.tryingToFetchDocs || docs.lastQueryParams.search !== this.state.search) ? 
                        <div>
                          <h1 className="translucent">searching <i className="fal fa-spinner-third fa-spin"/></h1>
                        </div>
                        :
                        <div>
                          <h1>search results:</h1>
                          <p className="lead">
                            Found {docs.pagination.totalDocs} doc{docs.pagination.totalDocs !== 1 && "s"} related to <strong>{this.state.search}</strong>
                          </p>
                          {
                            docs.pagination.totalDocs == 0 ?
                            <div className="list-left">
                              <Button
                                color="grey"
                                size="medium"
                                display="Clear Search"
                                onClick={(e)=>{
                                  this.props.change('search', "");
                                  this.setState({
                                    search: ""
                                  })
                                }}
                              />
                            </div>
                            :
                            
                              <div className="card-columns">
                                {
                                  docs.currentDocs.map((doc, i)=>{
                                    if(!docs.docCache[doc]) return;
                                    return <div className="card doc-exceprt-wrapper" key={i}>
                                      <Doc doc={docs.docCache[doc]} excerpt={true}/>
                                    </div>
                                  })
                                }
                              </div>
                            
                          }
                        </div>
                      }
                    </div>
                  }

                  {
                    // tag slug
                    tagSlug &&
                    <div>
                      <h1 className="h1-tag">{decodeHtml(this.state.currentTag)}</h1>
                      <div className="row row-eq-height">
                        {
                          docs.currentDocs.map((doc, i)=>{
                            if(!docs.docCache[doc]) return;
                            return <div className="col-md-4 doc-exceprt-wrapper" key={i}>
                              <Doc doc={docs.docCache[doc]} excerpt={true}/>
                            </div>
                          })
                        }
                      </div>
                    </div>
                  }

                  {
                    // category slug
                    (categorySlug && this.state.currentCategory && !docs.tryToFetchDocs) &&
                    <div>
                      <h1>{decodeHtml(this.state.currentCategory)}</h1>
                      <p className="lead">{this.state.currentCategory.description}</p>
                      <div className="row row-eq-height" key={categorySlug}>
                        {
                          docs.currentDocs.map((doc, i)=>{
                            if(!docs.docCache[doc]) return;
                            return <div className="col-md-4 doc-exceprt-wrapper" key={i + "_" + categorySlug}>
                              
                                <Doc doc={docs.docCache[doc]} excerpt={true}/>
                            </div>
                          })
                        }
                      </div>
                    </div>
                  }


                  {
                    // docs home
                    (this.state.search == "" && !slug && !tagSlug && !categorySlug) && 
                    <div>
                      <h1>Introduction</h1>
                      <p className="lead">
                        Whether you're a .pat file expert or just looking for a quick solution, learn how to get what you need from Pattycake to make your drawings better than ever.
                      </p>
                      <hr/>
                      <h4>
                        Don't know where to begin?
                      </h4>
                      <p>
                        Here are a few articles to help you get started:
                      </p>
                      <div className="row">
                        <div className="col-md-4 doc-exceprt-wrapper">
                          <Doc doc={docs.docCache[41]} excerpt={true}/>
                        </div>
                        <div className="col-md-4 doc-exceprt-wrapper">
                          <Doc doc={docs.docCache[20]} excerpt={true}/>
                        </div>
                        <div className="col-md-4 doc-exceprt-wrapper">
                          <Doc doc={docs.docCache[25]} excerpt={true}/>
                        </div>
                      </div>

                      <hr/>
                      <h4>
                        Need help with Pattycake?
                      </h4>
                      <p>
                        We know there is a lot packed into Pattycake, here are a few articles to help you get the most out of specific features:
                      </p>
                      <div className="row">
                        <div className="col-md-4 doc-exceprt-wrapper">
                          <Doc doc={docs.docCache[174]} excerpt={true}/>
                        </div>
                        <div className="col-md-4 doc-exceprt-wrapper">
                          <Doc doc={docs.docCache[147]} excerpt={true}/>
                        </div>
                        <div className="col-md-4 doc-exceprt-wrapper">
                          <Doc doc={docs.docCache[141]} excerpt={true}/>
                        </div>
                        <div className="col-md-4 doc-exceprt-wrapper">
                          <Doc doc={docs.docCache[205]} excerpt={true}/>
                        </div>
                      </div>

                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

DocsRoute = reduxForm({
  form: 'DocsRouteForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(DocsRoute)

DocsRoute = connect((state, ownProps) => {
  const { docs, user, patternManager } = state;

  var initialValues = {
    search: ""
  };
  
  return {
    user,
    docs,
    patternManager,
    initialValues
  }
})(DocsRoute);

export default DocsRoute;


// WEBPACK FOOTER //
// ./src/routes/Docs_WP.js